module.exports = __webpack_public_path__ + "static/img/texun666.bf65c20.png";